<!-- eslint-disable-next-line vue/valid-template-root -->
<template></template>
<script>
import { onMounted } from 'vue';
import confetti from 'canvas-confetti';

const PARTICLE_COUNT = 150;
const COLORS = ['#FFC700', '#FF0000', '#2E3191', '#41BBC7'];
export default {
    props: {
        particleCount: {
            type: Number,
            default: PARTICLE_COUNT,
        },
        zIndex: {
            type: Number,
            default: null,
        },
    },
    setup(props) {
        function fire(particleRatio, opts) {
            confetti({
                ...opts,
                particleCount: Math.floor(props.particleCount * particleRatio),
                colors: COLORS,
                ...(props.zIndex ? { zIndex: props.zIndex } : {}),
            });
        }
        onMounted(async () => {
            fire(0.25, {
                spread: 26,
                startVelocity: 55,
            });
            fire(0.2, {
                spread: 60,
            });
            fire(0.35, {
                spread: 100,
                decay: 0.91,
                scalar: 0.8,
            });
            fire(0.1, {
                spread: 120,
                startVelocity: 25,
                decay: 0.92,
                scalar: 1.2,
            });
            fire(0.1, {
                spread: 120,
                startVelocity: 45,
            });
        });
    },
};
</script>
